import {
  ADMINISTRATION,
  BUSINESS_PLAN,
  DASHBOARD,
  FORECAST,
  MAP,
  OPERATION_JOURNAL,
  OPERATION_JOURNAL_SHIFT_ACCEPTANCE,
  OPERATION_JOURNAL_SHIFT_TRANSFER,
  POWER_BI,
  RESTRICTIONS_JOURNAL,
  UNBALANCE_SIDEBAR,
} from './titles'

const VIEW = 'view'
const VIEW_CURRENT_PLANT = 'viewCurrentPlant'
const VIEW_ONLY_PLAN = 'viewOnlyPlan'
const VIEW_SHIFTS_HISTORY = 'viewShiftsHistory'
const EDIT = 'edit'
const CREATE = 'create'
const DELETE = 'delete'
const FILE_UPLOAD = 'uploadFile'
const FILE_DOWNLOAD = 'downloadFile'
const CALCULATION = 'calculation'
const COMMENT_CREATE = 'commentCreate'

// Dashboard
export const DASHBOARD_VIEW = `${DASHBOARD}:${VIEW}`
// PowerBI
export const POWER_BI_VIEW = `${POWER_BI}:${VIEW}`

// Unbalance
export const UNBALANCE_VIEW = `${UNBALANCE_SIDEBAR}:${VIEW}`

// Forecast
export const FORECAST_VIEW = `${FORECAST}:${VIEW}`

// Map
export const MAP_VIEW = `${MAP}:${VIEW}`

// BusinessPlan
export const BUSINESS_PLAN_AND_LOGS_VIEW = `${BUSINESS_PLAN}:${VIEW}`
export const BUSINESS_PLAN_ONLY_VIEW = `${BUSINESS_PLAN}:${VIEW_ONLY_PLAN}`
export const BUSINESS_PLAN_DOWNLOAD_TEMPLATE = `${BUSINESS_PLAN}:${FILE_DOWNLOAD}`
export const BUSINESS_PLAN_UPLOAD = `${BUSINESS_PLAN}:${FILE_UPLOAD}`

// Administration
export const ADMINISTRATION_VIEW = `${ADMINISTRATION}:${VIEW}`
export const ADMINISTRATION_EDIT = `${ADMINISTRATION}:${EDIT}`
export const ADMINISTRATION_CREATE = `${ADMINISTRATION}:${CREATE}`
export const ADMINISTRATION_DELETE = `${ADMINISTRATION}:${DELETE}`

// RestrictionJournal
export const RESTRICTIONS_JOURNAL_VIEW = `${RESTRICTIONS_JOURNAL}:${VIEW}`
export const RESTRICTIONS_JOURNAL_EDIT = `${RESTRICTIONS_JOURNAL}:${EDIT}`
export const RESTRICTIONS_JOURNAL_CREATE = `${RESTRICTIONS_JOURNAL}:${CREATE}`
export const RESTRICTIONS_JOURNAL_DELETE = `${RESTRICTIONS_JOURNAL}:${DELETE}`
export const RESTRICTIONS_JOURNAL_CALCULATION = `${RESTRICTIONS_JOURNAL}:${CALCULATION}`
export const RESTRICTIONS_JOURNAL_VIEW_CURRENT_PLANT = `${RESTRICTIONS_JOURNAL}:${VIEW_CURRENT_PLANT}`
// OperationJournal
export const OPERATION_JOURNAL_VIEW = `${OPERATION_JOURNAL}:${VIEW}`
export const OPERATION_JOURNAL_EDIT = `${OPERATION_JOURNAL}:${EDIT}`
export const OPERATION_JOURNAL_CREATE = `${OPERATION_JOURNAL}:${CREATE}`
export const OPERATION_JOURNAL_COMMENT_CREATE = `${OPERATION_JOURNAL}:${COMMENT_CREATE}`
export const OPERATION_JOURNAL_VIEW_CURRENT_PLANT = `${OPERATION_JOURNAL}:${VIEW_CURRENT_PLANT}`
// OperationJournal permissions for roles: Admin, Station Director, Station Shift Supervisor
export const OPERATION_JOURNAL_SHIFTS_HISTORY_VIEW = `${OPERATION_JOURNAL}:${VIEW_SHIFTS_HISTORY}`
export const OPERATION_JOURNAL_SHIFT_TRANSFER_VIEW = `${OPERATION_JOURNAL_SHIFT_TRANSFER}:${VIEW}`
export const OPERATION_JOURNAL_SHIFT_ACCEPTANCE_VIEW = `${OPERATION_JOURNAL_SHIFT_ACCEPTANCE}:${VIEW}`
